// @flow
import { TEXT } from 'Client/cms/toolkit/constants';
import { TextLine } from 'Components/lines/text-line/TextLine';

export const textDescriptor = {
  name: TEXT,
  component: TextLine,
};
